// Textes de référencement (titre + description) des pages de meteris.fr : la SOURCE UNIQUE, lue par
//  - chaque page (src/pages/*.js), qui les passe à <SEO> : c'est ce que lisent Google (après JavaScript) et le HTML
//    pré-rendu (le fixup y garde la valeur posée par la page) ;
//  - scripts/prerender-fixup.js : ROUTE_SEO (repli des balises quand une page n'a rien posé) et /llms.txt (lu par les
//    assistants IA).
// Jusqu'au 25/10/2026, chaque page avait DEUX jeux de textes (celui de la page et celui de ROUTE_SEO), qui divergeaient
// (les 8 pages par ville) : Google et les assistants IA ne lisaient pas la même description. Choix route par route :
// message du commit « fix(seo): une source unique pour les titres et descriptions ».
//
// Règles (tests : src/data/seoTextes.test.js) :
//  - rien qui contredise la page ou les décisions en vigueur (téléphone lun–ven 9 h–12 h / 14 h–17 h, atelier
//    16 h 30–18 h, 01 83 62 33 27) ; aucune promesse, aucun chiffre ni service absent de la page ;
//  - titre complet ≤ 65 caractères (suffixe « | METERIS » compris, ajouté seulement si le titre ne cite pas METERIS) ;
//  - description de 120 à 160 caractères (exception justifiée : /nos-horaires, texte exact de la décision du 23/10).
// Les articles /actualites/<slug> gardent leur texte venu de l'API : ils ne sont pas ici.
//
// En CommonJS (comme llmsTxt.js) : chargé par Node au pré-rendu et par webpack dans les pages.

const SITE_NAME = 'METERIS';

// Le titre tel que l'affiche le composant <SEO> : suffixé « | METERIS » s'il ne cite pas déjà METERIS. Même règle pour le
// repli du pré-rendu (ROUTE_SEO, articles) : jamais « … METERIS … | METERIS ».
function titreComplet(titre) {
  const t = String(titre || '');
  return t.includes(SITE_NAME) ? t : `${t} | ${SITE_NAME}`;
}

// Routes pré-rendues (package.json, reactSnap.include, dont la page introuvable /404).
const SEO_TEXTES = {
  '/': {
    title: 'METERIS — Infogérance, cybersécurité et téléphonie à Meaux (77)',
    description:
      'Infogérance, cybersécurité, téléphonie, serveurs et copieurs pour les PME et ETI de Meaux (77). Agents IA supervisés par nos techniciens, intervention sous 4 h.',
  },
  '/entreprise': {
    title: "L'entreprise METERIS — Équipe IT à Meaux et Seine-et-Marne",
    description:
      'Découvrez METERIS, société informatique B2B basée à Meaux : notre équipe, nos valeurs, notre histoire et notre présence auprès des PME et ETI de Seine-et-Marne.',
  },
  '/contact': {
    title: 'Contact METERIS — Agence Meaux (77100), Seine-et-Marne',
    description:
      'Contactez METERIS pour un audit gratuit, un devis ou un projet IT à Meaux et en Seine-et-Marne. Réponse sous 24 h ouvrées. Téléphone : 01 83 62 33 27.',
  },
  '/solutions/infogerance-cyber': {
    title: 'Infogérance et cybersécurité PME — METERIS Meaux (77)',
    description:
      'Infogérance complète, supervision 24/7, EDR, sauvegarde et PRA pour les PME et ETI de Seine-et-Marne. Audit cybersécurité gratuit par METERIS.',
  },
  '/solutions/telephonie': {
    title: "Téléphonie d'entreprise Yeastar — METERIS Meaux (77)",
    description:
      'Standard IPBX Yeastar, softphone Linkus, visio intégrée, économies de 30 à 50 % sur la facture télécom. Installation sans coupure par METERIS Gold Partner.',
  },
  '/solutions/copieurs': {
    title: 'Copieurs et impression managée — METERIS MPS Meaux (77)',
    description:
      "Gestion de parc d'impression multi-marques, maintenance et consommables inclus, audit gratuit. METERIS MPS pour les PME de Seine-et-Marne.",
  },
  '/solutions/serveurs-infrastructure': {
    title: "Serveurs et infrastructure d'entreprise — METERIS Meaux (77)",
    description:
      'Audit, dimensionnement, virtualisation, cloud hybride et sauvegarde Veeam pour les PME de Seine-et-Marne. Migration sans interruption par METERIS.',
  },
  '/solutions/ia-automatisation': {
    title: 'IA et automatisation pour entreprises — METERIS Meaux (77)',
    description:
      'IA souveraine, hébergement européen, automatisation des tâches répétitives, assistants internes formés sur vos données. ROI mesurable avec METERIS.',
  },
  '/solutions/formation': {
    title: 'Formations IT et IA certifiées Qualiopi — METERIS Meaux (77)',
    description:
      'Ateliers Microsoft 365, cybersécurité, IA pratique. Formations certifiées Qualiopi finançables OPCO, dispensées par MCF Formation, partenaire METERIS.',
  },
  '/actualites': {
    title: 'Actualités IT, cybersécurité et IA pour entreprises — METERIS',
    description:
      "Articles, retours d'expérience et conseils METERIS sur l'infogérance, la cybersécurité, la téléphonie et l'IA pour les entreprises de Meaux et Seine-et-Marne.",
  },
  '/nos-horaires': {
    title: 'Nos horaires — METERIS Meaux',
    // Texte EXACT de la décision horaires du 23/10/2026 (aligné le 25/10) : 177 caractères, exception à la règle des 160.
    description:
      'METERIS Meaux : accueil téléphonique du lundi au vendredi de 9 h à 12 h et de 14 h à 17 h ; atelier sans rendez-vous de 16 h 30 à 18 h. Intervention sous 4 h sur Seine-et-Marne.',
  },
  '/prendre-rdv': {
    title: 'Prendre rendez-vous — METERIS Atelier de Meaux',
    description:
      'Réservez un rendez-vous au comptoir METERIS (8 rue Georges Claude, Meaux) ou en visioconférence. Particuliers, TPE/PME, professions libérales et collectivités.',
  },
  '/devis-pc': {
    title: 'Configurer un devis PC sur mesure — METERIS Meaux (77)',
    description:
      'Configurez votre PC professionnel ou particulier sur mesure. Devis gratuit METERIS, livraison rapide en Seine-et-Marne et à Meaux.',
  },
  '/devenir-apporteur-daffaires': {
    title: "Devenir apporteur d'affaires — METERIS Meaux (77)",
    description:
      "Rejoignez le programme apporteur d'affaires METERIS : recommandez nos services IT aux entreprises de Seine-et-Marne, commission sur chaque contrat signé.",
  },
  '/google-app': {
    title: 'Connexion Google — METERIS',
    description:
      'Connexion Google aux services METERIS : accès réservé aux utilisateurs autorisés, données limitées au strict nécessaire, aucun usage marketing ou publicitaire.',
  },
  '/mentions-legales': {
    title: 'Mentions légales — METERIS',
    description:
      "Mentions légales et conditions d'utilisation des services METERIS : éditeur, engagements de l'utilisateur, accès et sécurité, responsabilité, contact.",
  },
  '/politique-confidentialite': {
    title: 'Politique de confidentialité — METERIS',
    description:
      'Politique de confidentialité METERIS : données collectées, finalités, conservation, droits RGPD, contact pour vos demandes.',
  },
  '/cookies': {
    title: 'Politique de cookies — METERIS',
    description:
      "Politique de cookies METERIS : mesure d'audience Matomo anonyme et sans cookie, cookies seulement si vous acceptez, plus aucune mesure si vous refusez.",
  },
  '/cgv-rdv': {
    title: 'Conditions de réservation — METERIS',
    description:
      "Conditions de réservation des rendez-vous à l'atelier METERIS de Meaux : annulation libre jusqu'à 48 h avant, absence non prévenue, nature du créneau.",
  },
  // Pages d'atterrissage par ville (src/pages/ExpertiseLocale.js, villes de src/data/locations.js) : un texte propre à
  // chaque ville (secteurs, distance), contre le contenu dupliqué ; le titre reprend le H1 de la page.
  '/expertise-locale/meaux': {
    title: 'Services informatiques à Meaux (77100) — METERIS',
    description:
      'Infogérance, cybersécurité, téléphonie, copieurs, serveurs et IA pour les entreprises de Meaux (77100). Atelier au 8 rue Georges Claude, intervention sous 4 h.',
  },
  '/expertise-locale/chelles': {
    title: 'Services informatiques à Chelles (77500) — METERIS',
    description:
      'Infogérance, cybersécurité, téléphonie et impression managée pour les entreprises de Chelles (77500). METERIS intervient sous 4 h depuis Meaux (25 km).',
  },
  '/expertise-locale/lagny-sur-marne': {
    title: 'Services informatiques à Lagny-sur-Marne (77400) — METERIS',
    description:
      'Audit IT, cybersécurité, téléphonie et infogérance pour les PME et professions libérales de Lagny-sur-Marne (77400). METERIS intervient sous 4 h depuis Meaux.',
  },
  '/expertise-locale/coulommiers': {
    title: 'Services informatiques à Coulommiers (77120) — METERIS',
    description:
      "Infogérance, cybersécurité et téléphonie pour les artisans, l'agroalimentaire et les PME de Coulommiers (77120). Audit gratuit, intervention depuis Meaux.",
  },
  '/expertise-locale/marne-la-vallee': {
    title: 'Services informatiques à Marne-la-Vallée (77700) — METERIS',
    description:
      "METERIS accompagne les sièges sociaux, parcs d'activité et campus de Marne-la-Vallée (Val d'Europe, Champs-sur-Marne) en infogérance, cybersécurité et IA.",
  },
  '/expertise-locale/roissy-en-brie': {
    title: 'Services informatiques à Roissy-en-Brie (77680) — METERIS',
    description:
      'Infogérance, cybersécurité et téléphonie pour les PME et collectivités de Roissy-en-Brie (77680). METERIS intervient sous 4 h depuis Meaux.',
  },
  '/expertise-locale/mitry-mory': {
    title: 'Services informatiques à Mitry-Mory (77290) — METERIS',
    description:
      "Infogérance et téléphonie pour la logistique, l'industrie et les services aéroportuaires de Mitry-Mory (77290), près de CDG. METERIS intervient depuis Meaux.",
  },
  '/expertise-locale/claye-souilly': {
    title: 'Services informatiques à Claye-Souilly (77410) — METERIS',
    description:
      'Infogérance, impression managée et cybersécurité pour les artisans et PME de Claye-Souilly (77410). METERIS intervient sous 4 h depuis Meaux (18 km).',
  },
  // Page « introuvable » : pré-rendue sur /404, copiée en build/404.html (noindex).
  '/404': {
    title: 'Page introuvable — METERIS',
    description:
      "La page demandée n'existe pas ou a été déplacée. Retrouvez les services informatiques METERIS depuis l'accueil, ou contactez-nous.",
  },
};

// Pages qui posent aussi leurs balises par <SEO> mais ne sont PAS pré-rendues (hors reactSnap.include) : mêmes règles,
// mais hors ROUTE_SEO, hors sitemap et hors llms.txt. Les deux dernières sont l'état « introuvable » d'une route
// dynamique (slug inconnu), en noindex.
const SEO_TEXTES_HORS_PRERENDU = {
  '/configurateur': {
    title: 'Configurateur — METERIS Atelier de Meaux',
    description:
      'Identifiez en quelques questions la prestation IT la plus adaptée à votre besoin, puis choisissez votre créneau de rendez-vous METERIS.',
  },
  '/prendre-rdv/annuler': {
    title: 'Annulation de rendez-vous — METERIS',
    description:
      "Annulez votre rendez-vous METERIS de Meaux en ligne : annulation libre jusqu'à 48 heures avant le rendez-vous ; au-delà, l'annulation est tardive.",
  },
  'solution-introuvable': {
    title: 'Solution introuvable',
    description:
      "La solution demandée n'existe pas ou a été déplacée. Retrouvez l'ensemble des solutions informatiques METERIS depuis la page d'accueil du site.",
  },
  'article-introuvable': {
    title: 'Article introuvable',
    description:
      "L'article demandé n'existe pas ou a été déplacé. Retrouvez les conseils IT, cybersécurité et IA de METERIS sur la page des actualités.",
  },
};

module.exports = { SITE_NAME, SEO_TEXTES, SEO_TEXTES_HORS_PRERENDU, titreComplet };
